module.exports = __webpack_public_path__ + "static/media/capy_logo_cn@2x.4ae64904.png";